define('views/shared/button/button',[
    'backbone',
    'views/_base/baseview',
    'text!views/shared/button/button.html',
    'views/shared/button/success_modal',
    'views/shared/button/error_modal',
    'views/shared/modal/modal_modern'
], function(Backbone, BaseView, Template, ButtonSuccessModalView, ButtonErrorModalView, Modal){
    'use strict';

    return BaseView.extend({
        className : 'button-container',
        tagName   : 'div',
        isRender  : true,
        needsAuth : false,
        template  : _.template(Template),
        events    : {
            'click .js-button-save'  : 'startProcess',
            'click .js-button-cancel': 'cancelProcess'
        },
        initialize: function(options){
            var options = options || {};
            
            // External Configuration Options

            // General
            this.calling_view = options.calling_view;
            this.render_in_parent = options.render_in_parent;
            
            // Transactional
            this.is_transaction = options.is_transaction;
            this.transaction_callback = (options.transaction_callback) ? options.transaction_callback : null;
            
            // Defaults
            this.btn_label = (options.btn_label) ? options.btn_label : 'Save';
            this.btn_callback = (options.btn_callback) ? options.btn_callback : null;
            this.btn_retry_callback = (options.btn_retry_callback) ? options.btn_retry_callback : null;

            // Confirm
            this.btn_confirm = options.btn_confirm;
            this.btn_confirm_amount = (options.btn_confirm_amount) ? options.btn_confirm_amount : 0;
            this.btn_confirm_label = (options.btn_confirm_label) ? options.btn_confirm_label : 'Confirm';
            this.btn_confirm_callback = (options.btn_confirm_callback) ? options.btn_confirm_callback : null;

            // Cancel
            this.btn_cancel = options.btn_cancel;
            this.btn_cancel_label = (options.btn_cancel_label) ? options.btn_cancel_label : 'Cancel';
            this.btn_cancel_callback = (options.btn_cancel_callback) ? options.btn_cancel_callback : null;

            // Cancel Modal
            this.btn_cancel_modal = options.btn_cancel_modal;
            this.btn_cancel_modal_label = (options.btn_cancel_modal_label) ? options.btn_cancel_modal_label : 'Cancel';
            this.btn_cancel_modal_callback = (options.btn_cancel_modal_callback) ? options.btn_cancel_modal_callback : null;

            // Success Modal
            this.btn_success_modal = options.btn_success_modal;
            this.btn_success_modal_header = (options.btn_success_modal_header) ? options.btn_success_modal_header : 'Success';
            this.btn_success_modal_delay = (options.btn_success_modal_delay) ? options.btn_success_modal_delay : 1500;
            this.btn_success_modal_label = (options.btn_success_modal_label) ? options.btn_success_modal_label : 'OK';
            this.btn_success_modal_message = (options.btn_success_modal_message) ? options.btn_success_modal_message : '';
            this.btn_success_modal_callback = (options.btn_success_modal_callback) ? options.btn_success_modal_callback : null;

            // Success
            this.btn_success = options.btn_success;
            this.btn_success_delay = (options.btn_success_delay) ? options.btn_success_delay : 1500;
            this.btn_success_label = (options.btn_success_label) ? options.btn_success_label : 'Success';
            this.btn_success_message = (options.btn_success_message) ? options.btn_success_message : '';
            this.btn_success_callback = (options.btn_success_callback) ? options.btn_success_callback : null;

            // Error Modal
            this.btn_error_modal = options.btn_error_modal;
            this.btn_error_modal_header = (options.btn_error_modal_header) ? options.btn_error_modal_header : 'Error';
            this.btn_error_modal_delay = (options.btn_error_modal_delay) ? options.btn_error_modal_delay : 1500;
            this.btn_error_modal_label = (options.btn_error_modal_label) ? options.btn_error_modal_label : 'OK';
            this.btn_error_modal_message = (options.btn_error_modal_message) ? options.btn_error_modal_message : '';
            this.btn_error_modal_callback = (options.btn_error_modal_callback) ? options.btn_error_modal_callback : null;

            // Error
            this.btn_error = options.btn_error;
            this.btn_error_delay = (options.btn_error_delay) ? options.btn_error_delay : 1500;
            this.btn_error_label = (options.btn_error_label) ? options.btn_error_label : '';
            this.btn_error_cancel_label = (options.btn_error_cancel_label) ? options.btn_error_cancel_label : 'Cancel';
            this.btn_error_message = (options.btn_error_message) ? options.btn_error_message : '';
            this.btn_error_callback = (options.btn_error_callback) ? options.btn_error_callback : null;

            // Cancel
            this.btn_forgot_password = options.btn_forgot_password;
            this.btn_forgot_password_label = (options.btn_forgot_password_label) ? options.btn_forgot_password_label : 'Forgot password?';

            // Internal Configurations
            this.is_confirmed = false;
            this.is_error_cancel = false;
            this.is_processing = false;
            this.proceeded_to_confirm = false;
            this.text_message_limit = 33;

            this.elementName = options.elementName;
            
            BaseView.prototype.initialize(this);
        },

        render: function(){

            this.$el.html(this.template());

            return this;
        },

        startProcess: function(e){
            if(e && e.preventDefault){ e.preventDefault(); }
            if(e && e.stopPropagation){ e.stopPropagation(); }
            
            // Do not proceed if process is still active
            if(this.is_processing){
                console.warn('Still Processing, do nothing');
                return false;
            }
            
            var button = $(e.currentTarget),
                confirming = button.hasClass('confirming'),
                success = button.hasClass('success'),
                error = button.hasClass('error');

            // If confirmation necessary
            if(this.btn_confirm){

                // console.log('startProcess',confirming,success,error,this.is_confirmed,this);

                // If user has not confirmed and the button is not in a confirm state
                if(!this.is_confirmed && !confirming){

                    // Do not allow financial transaction to go further if the transaction amount is 0
                    if(this.is_transaction && this.btn_confirm_amount == 0){

                        if(_.isFunction(this.transaction_callback)){

                            if(this.transaction_callback.name){
                                this.calling_view[this.transaction_callback.name]();
                            } else {
                                this.transaction_callback(this.calling_view);
                            }
                            
                        }

                        return false;
                    }

                    if(_.isFunction(this.btn_callback) && !this.proceeded_to_confirm){
                        
                        if(this.btn_callback.name){
                            this.calling_view[this.btn_callback.name](this.proceedToConfirm);
                        } else {
                            this.btn_callback(this.proceedToConfirm, this.calling_view);
                        }

                    }

                } else if(confirming){
                    // If the button is in the confirm state and the user "confirms"

                    // Change the button to processing
                    this.changeToProcessingState();

                    // Hide the cancel button when processing
                    this.hideCancelButton();

                    // Update internal confirmation status
                    this.is_confirmed = true;

                    // Notify calling view that user has confirmed
                    if(_.isFunction(this.btn_confirm_callback)){
                        
                        if(this.btn_confirm_callback.name){
                            this.calling_view[this.btn_confirm_callback.name](this.processComplete);
                        } else {
                            this.btn_confirm_callback(this.processComplete, this.calling_view);
                        }

                    }

                } else {

                    if(success){

                        if(_.isFunction(this.btn_success_callback)){

                            if(this.btn_success_callback.name){
                                this.calling_view[this.btn_success_callback.name](this.resetButtonState);
                            } else {
                                this.btn_success_callback(this.resetButtonState, this.calling_view);
                            }
                            
                        }

                    }

                    if(error){

                        // Assuming re-try
                        this.changeToProcessingState();

                        // Hide the cancel button when processing
                        this.hideCancelButton();

                        // Reset this for retry
                        this.is_confirmed = false;

                        if(_.isFunction(this.btn_confirm_callback)){
                            
                            if(this.btn_confirm_callback.name){
                                this.calling_view[this.btn_confirm_callback.name](this.processComplete);
                            } else {
                                this.btn_confirm_callback(this.processComplete, this.calling_view);
                            }
                            
                        }

                    }

                }
                
            } else {

                if(success){

                    if(_.isFunction(this.btn_success_callback)){
                        
                        if(this.btn_success_callback.name){
                            this.calling_view[this.btn_success_callback.name](this.resetButtonState);
                        } else {
                            this.btn_success_callback(this.resetButtonState, this.calling_view);
                        }
                        
                    }

                } else if(error){

                    // Assuming re-try
                    this.changeToProcessingState();

                    // Hide the cancel button when processing
                    this.hideCancelButton();

                    // Reset this for retry
                    this.is_confirmed = false;

                    if(_.isFunction(this.btn_retry_callback)){
                        
                        if(this.btn_retry_callback.name){
                            this.calling_view[this.btn_retry_callback.name](this.processComplete);
                        } else {
                            this.btn_retry_callback(this.processComplete, this.calling_view);
                        }
                        
                    }

                } else {

                    // If no confirmation is needed, use the default button callback
                    // TODO: Give option of success/error feedback
                    if(_.isFunction(this.btn_callback)){
                        
                        this.changeToProcessingState();

                        if(this.btn_callback.name){
                            this.calling_view[this.btn_callback.name](this.processComplete);
                        } else {
                            this.btn_callback(this.processComplete, this.calling_view);
                        }

                    }

                }

            }
        },

        proceedToConfirm: function(that){
            var that = (that) ? that : this,
                button = that.$('.js-button-save'),
                confirm_label = (that.btn_confirm) ? that.btn_confirm_label : '',
                confirm_amount = (that.btn_confirm_amount > 0) ? formatBalanceCurrency(that.btn_confirm_amount) : '',
                confirm_html = (confirm_amount != '') ? confirm_label + ' ' + confirm_amount : confirm_label;

            // Change button
            button.addClass('btn--green confirming');
            button.html(confirm_html);

            that.proceeded_to_confirm = true;
        },

        processComplete: function(success, that){
            var that = (that) ? that : this,
                save_button = that.$('.js-button-save');

            if(success){

                save_button.addClass('circle');
                save_button.addClass('btn--green');
                save_button.removeClass('processing');
                save_button.html(enums.svg.checkIcon);

                if(that.btn_success_modal){

                    setTimeout(function(){
                        that.showProcessModalSuccess(that);
                        that.is_processing = false;
                    }, that.btn_success_modal_delay);

                } else if(that.btn_success){

                    setTimeout(function(){
                        that.showProcessSuccess(that);
                        that.is_processing = false;
                    }, that.btn_success_delay);

                } else if(that.btn_success == false || that.btn_success_modal == false){

                    if(_.isFunction(that.btn_success_callback)){
                        
                        if(that.btn_success_callback.name){
                            that.calling_view[that.btn_success_callback.name](that.resetButtonState);
                        } else {
                            that.btn_success_callback(that.resetButtonState, that.calling_view);
                        }
                        
                    }

                }

            } else {

                save_button.addClass('btn--red');
                save_button.addClass('circle');
                save_button.removeClass('btn--green');
                save_button.removeClass('processing');
                save_button.html(enums.svg.closeBtnIcon);

                that.is_error_cancel = true;

                if(that.btn_error_modal){

                    setTimeout(function(){
                        that.showProcessModalError(that);
                        that.is_processing = false;
                    }, that.btn_error_modal_delay);

                } else if(that.btn_error){

                    setTimeout(function(){
                        that.showProcessError(that);
                        that.is_processing = false;
                    }, that.btn_error_delay);

                }

            }
            
        },

        showProcessModalError: function(that){
            var that = (that) ? that : this;

            var data = {
                    btn_error_modal_header: that.btn_error_modal_header,
                    btn_error_modal_message: that.btn_error_modal_message,
                    btn_error_modal_label: that.btn_error_modal_label
                },
                linked_bank_error_view = new ButtonErrorModalView({ data: data, calling_view: that }),
                modal = new Modal({
                    show        : true,
                    content     : linked_bank_error_view.$el.html(),
                    calling_view: linked_bank_error_view
                });
        },

        errorModalCallbackMODAL: function(){

            this.resetButtonState();

            if(_.isFunction(this.btn_error_modal_callback)){

                if(this.btn_error_modal_callback.name){
                    this.calling_view[this.btn_error_modal_callback.name](this.resetButtonState);
                } else {
                    this.btn_error_modal_callback(this.resetButtonState, this.calling_view);
                }
                
            }

        },

        showProcessModalSuccess: function(that){
            var that = (that) ? that : this;

            var data = {
                    btn_success_modal_header: that.btn_success_modal_header,
                    btn_success_modal_message: that.btn_success_modal_message,
                    btn_success_modal_label: that.btn_success_modal_label,
                    btn_cancel_modal: that.btn_cancel_modal,
                    btn_cancel_modal_label: that.btn_cancel_modal_label,
                    btn_cancel_modal_callback: that.btn_cancel_modal_callback
                },
                btn_success_modal_view = new ButtonSuccessModalView({ data: data, calling_view: that }),
                modal = new Modal({
                    show        : true,
                    content     : btn_success_modal_view.$el.html(),
                    calling_view: btn_success_modal_view
                });
        },

        successModalCallbackMODAL: function(){

            this.closeMODAL();

            if(_.isFunction(this.btn_success_modal_callback)){

                if(this.btn_success_modal_callback.name){
                    this.calling_view[this.btn_success_modal_callback.name](this.resetButtonState);
                } else {
                    this.btn_success_modal_callback(this.resetButtonState, this.calling_view);
                }
                
            }

        },

        showProcessSuccess: function(that){
            var that = (that) ? that : this,
                save_button = that.$('.js-button-save'),
                feedback = that.$('.js-button-process-complete-feedback');

            // If the success message is too long, then show in a modal
            if(that.btn_success_message.toString().length > that.text_message_limit){
                that.updateSuccessModalMessage(that.btn_success_message);
                that.btn_success_modal_callback = that.btn_success_callback;
                that.showProcessModalSuccess();
                return false;
            }

            feedback.html('<span><img src="img/icons/icon-check-green.png" />' + that.btn_success_message + '</span>');
            feedback.addClass('success');
            feedback.fadeIn();

            save_button.removeClass('processing');
            save_button.removeClass('circle');
            save_button.addClass('btn--green');
            save_button.addClass('success');
            save_button.html(that.btn_success_label);

        },

        showProcessError: function(that){
            var that = (that) ? that : this,
                save_button = that.$('.js-button-save'),
                cancel_button = that.$('.js-button-cancel'),
                feedback = that.$('.js-button-process-complete-feedback');

            // If the error message is too long, then show in a modal
            if(that.btn_error_message){

                if(that.btn_error_message.toString().length > that.text_message_limit){
                    that.updateErrorModalMessage(that.btn_error_message);
                    that.btn_error_modal_callback = that.btn_error_callback;
                    that.showProcessModalError();
                    return false;
                }

                feedback.html('<span><img src="img/icons/icon-close-red.png" />' + that.btn_error_message + '</span>');

            }

            feedback.addClass('error');
            feedback.fadeIn();

            save_button.removeClass('processing');
            save_button.removeClass('circle');
            save_button.addClass('btn--red');
            save_button.addClass('error');
            save_button.html(that.btn_error_label);

            if(that.btn_cancel){
                cancel_button.html(that.btn_error_cancel_label);
                cancel_button.show();
            }

        },

        hideCancelButton: function(){
            this.$('.js-button-cancel').hide();
        },

        changeToProcessingState: function(){
            var save_button = this.$('.js-button-save'),
                cancel_button = this.$('.js-button-cancel'),
                feedback = this.$('.js-button-process-complete-feedback');

            feedback.fadeOut();
            feedback.removeClass('success');
            feedback.removeClass('error');
            feedback.html('');

            save_button.removeClass('error');
            save_button.removeClass('success');
            save_button.removeClass('confirming');
            save_button.removeClass('btn--red');

            if(this.btn_confirm){
                save_button.addClass('btn--green');
            }

            if(this.btn_cancel){
                cancel_button.hide();
            }

            save_button.addClass('processing');
            save_button.html(enums.svg.spinnerDarkBlueIcon);

            this.is_error_cancel = false;
            this.is_processing = true;

        },

        updateErrorMessage: function(text){
            this.btn_error_message = text;
        },

        updateErrorModalMessage: function(text){
            this.btn_error_modal_message = text;
        },

        updateSuccessMessage: function(text){
            this.btn_success_message = text;
        },

        updateSuccessModalMessage: function(text){
            this.btn_success_modal_message = text;
        },

        updateCofirmAmount: function(num){
            this.btn_confirm_amount = Number(num);
        },

        resetButtonState: function(that){
            var that = (that) ? that : this,
                save_button = that.$('.js-button-save'),
                cancel_button = that.$('.js-button-cancel'),
                feedback = that.$('.js-button-process-complete-feedback');

            feedback.fadeOut();
            feedback.removeClass('success');
            feedback.removeClass('error');
            feedback.html('');

            save_button.removeClass('circle');
            save_button.removeClass('error');
            save_button.removeClass('processing');
            save_button.removeClass('success');
            save_button.removeClass('confirming');
            save_button.removeClass('btn--red');
            save_button.removeClass('btn--green');
            save_button.html(that.btn_label);

            that.is_confirmed = false;
            that.is_error_cancel = false;
            that.is_processing = false;

            if(that.btn_cancel){
                cancel_button.html(that.btn_cancel_label);
                cancel_button.show();
            }

        },

        cancelProcess: function(e){
            if(e && e.preventDefault){ e.preventDefault(); }
            if(e && e.stopPropagation){ e.stopPropagation(); }

            this.is_confirmed = false;

            this.resetButtonState();

            if(_.isFunction(this.btn_cancel_callback) && !this.is_error_cancel){
                
                if(this.btn_cancel_callback.name){
                    this.calling_view[this.btn_cancel_callback.name]();
                } else {
                    this.btn_cancel_callback(this.calling_view);
                }
                
            } else if(_.isFunction(this.btn_error_callback) && this.is_error_cancel){
                
                if(this.btn_error_callback.name){
                    this.calling_view[this.btn_error_callback.name]();
                } else {
                    this.btn_error_callback(this.calling_view);
                }
                
            }

        },

        closeMODAL: function(){
            $('#pf-modal-modern').fadeOut(function(){
                $('#pf-modal-modern').remove();
            });
        },

        close: function(){}
    });
});

